module.exports = __webpack_public_path__ + "img/woodland_striders.c5fa817b.png";